// extracted by mini-css-extract-plugin
export default {"editSkill":"style_editSkill__5HhGP","communityStatus":"style_communityStatus__EDNMa","title":"style_title__cu8kO","inputField":"style_inputField__In7HB"};